import axios from '@/components/api/axios';

async function getRepeatOrder(bc) {
  let data = {
    // bcNo: localStorage.getItem('subNowBC')
    bcNo: bc
  }
  const res = await axios.axiosGet('/api/repeatOrder/getList', data);
  return res;
}

async function repeatGetDeliveryTimeList(bcNo) {
  let data = {
    bcNo: bcNo || localStorage.getItem('subNowBC')
  };
  const res = await axios.axiosGet('/api/repeatOrder/getDeliveryTimeList', data);
  return res;
}

async function repeatGetPayment(bcNo) {
  let data = {
    bcNo: bcNo || localStorage.getItem('subNowBC')
  };

  const res = await axios.axiosGet('/api/repeatOrder/getPaymentMethodList', data);
  return res;
}

async function simulate(deliveryTimeId, paymentMethodId, repeatOrderList, denyCreditDeliveryFlag) {
  let data = {
    bcNo: localStorage.getItem('subNowBC'),
    deliveryTimeId: deliveryTimeId,
    denyCreditDeliveryFlag: denyCreditDeliveryFlag,
    paymentMethodId: paymentMethodId,
    repeatOrderList: repeatOrderList,
  };

  const res = await axios.axiosPost('/api/repeatOrder/simulate', data);
  return res;
}

async function repeatOrderUpdate(data) {
  const res = await axios.axiosPut('/api/repeatOrder/update', data);
  return res;
}

async function getDenyCreditDelivery(bcNo) {
  let data = {
    bcNo: bcNo,
  };
  const res = await axios.axiosGet('/api/repeatOrder/getDenyCreditDelivery', data);
  return res;
}

// 複数BCの定期購入シミュレーション
async function simulateMonthly(requestData) {
  const res = await axios.axiosPost('/api/repeatOrder/simulateMonthly', requestData);
  return res;
}

// 複数BCの定期購入一括作成
async function createMultipleBcRepeatOrder(requestData) {
  const res = await axios.axiosPost('/api/repeatOrder/createMultipleBcRepeatOrder', requestData);
  return res;
}

export default {
  getRepeatOrder,
  repeatGetDeliveryTimeList,
  repeatGetPayment,
  simulate,
  repeatOrderUpdate,
  getDenyCreditDelivery,
  simulateMonthly,
  createMultipleBcRepeatOrder
}



// WEBPACK FOOTER //
// ./src/components/api/repeatOrder.js